<template>
  <el-button
    round
    size="small"
    :disabled="disabled"
    class="inline-flex items-center justify-start border-0 rounded-full bg-gray-100 px-6 py-1 text-sm text-th-secondary text-left font-medium cursor-pointer chip ml-0 h-auto whitespace-normal"
    data-testid="ai-chat-prompt-chip-button"
    @click="emit('click', text)"
  >
    {{ text }}
  </el-button>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    text?: string
    /* the chat cannot take a question, e.g. no credits are left */
    disabled?: boolean
  }>(),
  { text: '', disabled: false }
)

const emit = defineEmits<{
  click: [text: string]
}>()
</script>

<style scoped>
.chip:hover {
  background-color: #eaebed !important;
}
</style>
